export const downloads = [
  {
    name: "轻连桌面助手",
    icon: "ri-computer-line",
    platform: "Windows / macOS",
    version: "v3.2.1",
    size: "18.4 MB",
    desc: "把浏览器里常用的小工具搬到桌面，支持离线处理与快捷键唤起。",
    tag: "编辑推荐",
    tone: "primary",
  },
  {
    name: "静音电台客户端",
    icon: "ri-headphone-line",
    platform: "Windows / Android",
    version: "v2.8.0",
    size: "24.1 MB",
    desc: "无需打开网页即可听歌单，后台占用低，适合长时间挂着当背景音。",
    tag: "热门",
    tone: "accent",
  },
  {
    name: "随手记事本插件",
    icon: "ri-sticky-note-line",
    platform: "浏览器扩展",
    version: "v1.9.4",
    size: "3.6 MB",
    desc: "在任意网页侧边唤起速记面板，选中文字即可一键存为笔记。",
    tag: "轻量",
    tone: "secondary",
  },
  {
    name: "文档速查离线包",
    icon: "ri-file-list-3-line",
    platform: "全平台",
    version: "v5.1.2",
    size: "42.8 MB",
    desc: "把常用快捷键与命令速查表打包成离线文档，断网时也能随手查阅。",
    tag: "离线可用",
    tone: "primary",
  },
];